// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"SectionTitle_SectionTitle__3CmD1"};